import Vue from 'vue';

class EmptyNull {
  constructor() {
    this.id = data.newGuid();
  }
}

export const data = {
  EMPTY: 'he',
  //
  // actions
  //
  add(state, paths, value) {
    var nodePaths = paths.slice(0, -1);
    var lastPath = paths[paths.length - 1];

    var originalNode = this.getOrCreateNodeAt(state.original_values, nodePaths);
    if (originalNode != null)
      Vue.set(originalNode, lastPath, this.EMPTY);

    var currentNode = this.getOrCreateNodeAt(state, nodePaths);
    var oldValue = currentNode[lastPath];
    Vue.set(currentNode, lastPath, value);

    this.handleEvent(state.event_handlers, paths, 'add', value, oldValue);
  },
  update(state, paths, value) {
    var nodePaths = paths.slice(0, -1);
    var lastPath = paths[paths.length - 1];

    var originalNode = this.getOrCreateNodeAt(state.original_values, nodePaths);
    var currentNode = this.getOrCreateNodeAt(state, nodePaths);
    // value not changed
    if (this.compare(currentNode[lastPath], value))
      return;
    // not added
    if (originalNode !== null) {
      // not changed yet
      if (originalNode[lastPath] === undefined)
        Vue.set(originalNode, lastPath, currentNode[lastPath]);
      // same value as original
      else if (this.compare(originalNode[lastPath], value)) {
        Vue.delete(originalNode, lastPath);
        this.cleanEmptyNodes(state.original_values, paths);
      }
      // is node
      else if (this.isNode(originalNode[lastPath])) {
        this.forEachValue(currentNode[lastPath], (pathsI, currentValueI) => {
          if (pathsI.length == 0) {
            var oldValue = originalNode[lastPath];
            Vue.set(originalNode, lastPath, currentValueI);

            this.handleEvent(state.event_handlers, paths, 'update', value, oldValue);
            return;
          }

          var nodePathsI = pathsI.slice(0, -1);
          var lastPathI = pathsI[pathsI.length - 1];

          var originalNodeI = this.getOrCreateNodeAt(originalNode[lastPathI], nodePathsI);

          if (originalNodeI !== null && originalNodeI[lastPathI] === undefined)
            Vue.set(originalNodeI, lastPathI, currentValueI);
        });
      }
    }

    var oldValue = currentNode[lastPath];
    Vue.set(currentNode, lastPath, value);

    this.handleEvent(state.event_handlers, paths, 'update', value, oldValue);
  },
  remove(state, paths) {
    var nodePaths = paths.slice(0, -1);
    var lastPath = paths[paths.length - 1];

    var originalNode = this.getOrCreateNodeAt(state.original_values, nodePaths);
    var currentNode = this.getOrCreateNodeAt(state, nodePaths);
    // added parent - do nothing
    // else
    if (originalNode !== null) {
      // added - remove null
      if (originalNode[lastPath] === this.EMPTY)
        Vue.delete(originalNode, lastPath);

      // it is firstly changed => put all params to changes
      else if (this.isEmptyNode(originalNode[lastPath]))
        Vue.set(originalNode, lastPath, currentNode[lastPath]);

      // changed with inner data - append data
      else if (this.isNode(originalNode[lastPath])) {
        this.forEachValue(currentNode[lastPath], (pathsI, currentValueI) => {
          var nodePathsI = pathsI.slice(0, -1);
          var lastPathI = pathsI[pathsI.length - 1];

          var originalNodeI = this.getOrCreateNodeAt(originalNode[lastPath], nodePathsI);

          if (originalNodeI != null && originalNodeI[lastPathI] === undefined)
            Vue.set(originalNodeI, lastPathI, currentValueI);
        });
      }
      // changed value - leave original value
    }

    this.cleanEmptyNodes(state.original_values, paths);

    var oldValue = currentNode[lastPath];
    Vue.delete(currentNode, lastPath);
    this.handleEvent(state.event_handlers, paths, 'remove', null, oldValue);
  },
  forEachValue(data, action) {
    var todoProp = [{
      value: data,
      paths: []
    }];

    while (todoProp.length > 0) {
      var currentProp = todoProp.pop();

      // node
      if (this.isNode(currentProp.value)) {
        Object.keys(currentProp.value).forEach(propName => todoProp.push({
          value: currentProp.value[propName],
          paths: currentProp.paths.concat([propName])
        }));
        // remove
      } else {
        action(currentProp.paths, currentProp.value);
      }
    }
  },
  reset(state) {
    this.forEachValue(state.original_values, (paths, value) => {
      // remove
      if (value == this.EMPTY) {
        this.remove(state, paths);
        // add
      } else if (this.getValueAt(state, paths) === undefined) {
        this.add(state, paths, value);
        // update
      } else {
        this.update(state, paths, value);
      }
    });

    state.original_values = {};
    state.validation_errors = {};
  },

  //
  // helpers
  //
  getValueAt(data, paths) {
    if (paths.length == 0 || paths[0] == '')
      return data;

    var currentNode = data;
    paths.forEach(path_part => {
      // empty
      if (currentNode === undefined || currentNode == null || currentNode == this.EMPTY)
        return;

      currentNode = currentNode[path_part];
    });

    return currentNode;
  },
  getOrCreateNodeAt(data, paths) {
    var currentNode = data;
    paths.forEach(path => {
      // empty
      if (currentNode == null || currentNode == this.EMPTY)
        return;

      if (currentNode[path] === undefined)
        Vue.set(currentNode, path, {});

      currentNode = currentNode[path];
    });

    if (currentNode == this.EMPTY)
      return null;

    return currentNode;
  },
  cleanEmptyNodes(data, original_paths) {
    var paths = original_paths.slice(0); // clone
    var currentNode = this.getValueAt(data, paths);

    while (paths.length > 0 && this.isEmptyNode(currentNode)) {
      var lastPath = paths.pop();
      currentNode = this.getValueAt(data, paths);
      if (currentNode === undefined || currentNode === null)
        continue;

      Vue.delete(currentNode, lastPath);
    }
  },
  handleEvent(handlers, paths, type, newValue, oldValue) {
    var goThrought = [handlers];

    paths.forEach(path => {
      var next = [];
      goThrought.forEach(h => {
        if (h[path] !== undefined)
          next.push(h[path]);

        if (h['*'] !== undefined)
          next.push(h['*']);
      });

      goThrought = next;
    });

    goThrought.forEach(n => {
      var actions = this.getAllEventChildren(n);
      actions.forEach(a => {
        a(type, paths, newValue, oldValue);
      });
    })
  },
  getAllEventChildren(node) {
    var goThrought = [node];
    var result = [];
    while (goThrought.length > 0) {
      var next = [];
      goThrought.forEach(n => {
        Object.keys(n).forEach(key => {
          if (key == '~')
            result = result.concat(Object.values(n['~']));
          else
            next.push(n[key]);
        });
      })

      goThrought = next;
    }

    return result;
  },

  //
  // checkers
  //
  isEmptyNode(node) {
    if (node === undefined)
      return true;
    if (node == null)
      return false;

    var todoNodes = [node];

    while (todoNodes.length > 0) {
      var current = todoNodes.pop();

      if (this.isNode(current)) {
        Object.keys(current).forEach(key => {
          todoNodes.push(current[key]);
        })
      }
      else
        return false;
    }

    return true;
  },
  isNode(object) {
    return (object != null // null is a value
      && !(object instanceof EmptyNull) // empty value
      && !(object instanceof Date) // date is a value
      && typeof (object) === 'object'); // object
  },
  compare(value1, value2) {
    if (value1 instanceof Date && value2 instanceof Date)
      return value1.getTime() == value2.getTime();

    return value1 == value2;
  },

  newGuid() {
    return (this.randomHex() + this.randomHex() + "-" + this.randomHex() + "-4" + this.randomHex().substr(0, 3) + "-" + this.randomHex() + "-" + this.randomHex() + this.randomHex() + this.randomHex()).toLowerCase();
  },
  randomHex() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
};

export const msg = {
  post(path, data, context, callback, onError) {
    var requestId = Math.floor(Math.random() * 1000000000);
    context.commit('addSpinner', requestId);
    Vue.http.post(this.getUrl() + path, data, { headers: { Authorization: "Bearer " + context.state.login.jwtToken } })
      .finally(() => context.commit('removeSpinner', requestId))
      .then(resp => callback(resp.body))
      .catch(onError || ((err) => this.error(context, err)));
  },
  get(path, context, callback) {
    var requestId = Math.floor(Math.random() * 1000000000);
    context.commit('addSpinner', requestId);
    Vue.http.get(this.getUrl() + path, { headers: { Authorization: "Bearer " + context.state.login.jwtToken } })
      .finally(() => context.commit('removeSpinner', requestId))
      .then(resp => callback(resp.body))
      .catch((err) => {
        if (err.status == 401)
          context.commit("logout", true);
        else
          this.error(context, err);
      });
  },
  getDownload(path, context) {
    this.getByte(path, context, async response => {
      var contentHeader = response.headers.map["content-disposition"][0];
      var start = contentHeader.indexOf("filename=") + "filename=".length;
      var end = contentHeader.indexOf(";", start);
      var filename = contentHeader.substring(start, end);

      const data = await response.blob();
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(data);
      link.download = filename;
      link.click();
    });
  },
  getByte(path, context, callback) {
    var requestId = Math.floor(Math.random() * 1000000000);
    context.commit('addSpinner', requestId);
    Vue.http.get(this.getUrl() + path, { headers: { Authorization: "Bearer " + context.state.login.jwtToken }, responseType: 'blob' })
      .finally(() => context.commit('removeSpinner', requestId))
      .then(resp => callback(resp))
      .catch((err) => {
        if (err.status == 401)
          context.commit("logout", true);
        else
          this.error(context, err);
      });
  },
  error(context, err) {
    console.log(err);
    let texts = [err];
    if (err.body != null)
      texts = [err.body];
    if (err.body != null && err.body.some != null && err.body.some(er => er.message != null))
      texts = err.body.filter(er => er.severity == "Error").map(er => er.message);
    if (err.status == 0)
      texts = ["Nepodařilo se připojit k serveru. Jste připojen k Internetu?"];
    if (err.status == 401)
      texts = ["Neoprávněný přístup. Zkuste se odhlásit a znovu přihlásit."];
  
    if (texts.some(t => t == "Prosím vyplňte kontaktní údaje za hlídku!"))
      location.hash = '#outpost';

    texts.forEach(text => context.commit("notify", {
      text: text,
      level: "danger"
    }));
  },
  getUrl() {
    return window.location.href.split('/').slice(0, 3).join('/');
  }
};

export const datetime = {
  stringToDate(value) {
    if (value == null) return null;
    if (value instanceof Date) return value;

    var dateParser = /^(\d{4})-(\d{2})-(\d{2})T$/;
    var dateRegex = value.match(dateParser);
    if (dateRegex == null) return null;

    var date = new Date(Date.UTC(dateRegex[1], dateRegex[2] - 1, dateRegex[3]));

    return date;
  },
  stringToDateTime(value) {
    if (value == null) return null;
    if (value instanceof Date) return value;

    var dateParser = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(\.\d*)?/;
    var dateRegex = value.match(dateParser);
    if (dateRegex == null) return null;

    var date = new Date(Date.UTC(dateRegex[1], dateRegex[2] - 1, dateRegex[3], dateRegex[4], dateRegex[5], dateRegex[6]));

    return date;
  },
  czechStringToDate(value) {
    if (value == null) return null;

    var dateParser = /^(\d{1,2})\. ?(\d{1,2})\. ?(\d{4})$/;
    var dateRegex = value.match(dateParser);
    if (dateRegex == null) return null;

    var date = new Date(Date.UTC(dateRegex[3], dateRegex[2] - 1, dateRegex[1]));

    return date;
  },
  czechStringToDateTime(value) {
    if (value == null) return null;

    var dateParser = /^(\d{1,2})\. ?(\d{1,2})\. ?(\d{4}) (\d{1,2}):(\d{1,2})$/;
    var dateRegex = value.match(dateParser);
    if (dateRegex == null) return null;

    var date = new Date(dateRegex[3], dateRegex[2] - 1, dateRegex[1], dateRegex[4], dateRegex[5]);

    return date;
  },
  dateToString(value) {
    if (value == null) return null;

    var dateString = value.getUTCFullYear() +
      "-" +
      (value.getUTCMonth() + 1).toString().padStart(2, '0') +
      "-" +
      value.getUTCDate().toString().padStart(2, '0') +
      "T" +
      value.getUTCHours().toString().padStart(2, '0') +
      ":" +
      value.getUTCMinutes().toString().padStart(2, '0') +
      ":" +
      value.getUTCSeconds().toString().padStart(2, '0');

    return dateString;
  },
  dateToCzechString(value) {
    if (value == null) return null;

    return value.toLocaleDateString("cs-CZ");
  },
  datetimeToCzechString(value) {
    if (value == null) return null;

    return `${value.getDate()}. ${value.getMonth() + 1}. ${value.getFullYear()} ${value.getHours()}:${value.getMinutes().toString().padStart(2, '0')}`;
  },
  parseAll(objectValue) {
    Object.keys(objectValue).forEach(key => {
      const value = objectValue[key];
      if (value == null) return;

      if (typeof value === 'string') {
        var date = this.stringToDateTime(value)
        if (date) objectValue[key] = date;
        else {
          date = this.stringToDate(value);
          if (date) objectValue[key] = date;
        }
      }

      if (typeof value === 'object')
        this.parseAll(value);
    });
  }
};

export const common = {
  sortBy(array, getter, asc = 1) {
    array.sort((a, b) => {
      const valA = getter(a);
      const valB = getter(b);
      var result = this.compare(valA, valB);
      return result * asc;
    });
  },

  compare(valA, valB) {
    if (valA == undefined && valB == undefined)
      return 0;

    if (valA == undefined)
      return 1;

    if (valB == undefined)
      return -1;

    if (valA < valB)
      return -1;

    if (valA > valB)
      return 1;

    return 0;
  },

  getDates(startDate, endDate) {
    const result = [];
    for (let currentDate = new Date(startDate); currentDate <= endDate; currentDate.setDate(currentDate.getDate()+1)) {
      result.push(new Date(currentDate));
    }
    return result;
  },
};

data.EMPTY = new EmptyNull();
